interface Props {
  source?: string;
}

export function Recording({ source }: Props) {
  return (
    <div className="recording-overlay">
      <div className="recording-header">
        <span className="recording-indicator">REC</span>
        <span className="recording-title">RECORDED TRANSMISSION</span>
      </div>
      {source && (
        <div className="recording-source">SOURCE: {source.toUpperCase()}</div>
      )}
      <div className="recording-waveform">
        {Array.from({ length: 32 }).map((_, i) => (
          <div
            key={i}
            className="recording-bar"
            style={{
              animationDelay: `${i * 0.05}s`,
              height: `${20 + Math.sin(i * 0.8) * 15 + Math.random() * 10}%`,
            }}
          />
        ))}
      </div>
      <div className="recording-static">
        {Array.from({ length: 60 }).map((_, i) => (
          <div
            key={i}
            className="static-dot"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 2}s`,
              animationDuration: `${0.5 + Math.random() * 1.5}s`,
            }}
          />
        ))}
      </div>
    </div>
  );
}
